import { ChangeDetectionStrategy, Component } from "@angular/core";
import { VideoLightboxService } from "@rubbl-marketing";

@Component({
  selector: "app-list-your-machines-header",
  templateUrl: "./list-your-machines-header.component.html",
  styleUrls: ["./list-your-machines-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListYourMachinesHeaderComponent {
  constructor(private videoLightboxService: VideoLightboxService) {}

  watchVideo() {
    this.videoLightboxService.create("https://www.youtube.com/embed/C4azgAkZuUc?autoplay=1&rel=0");
  }
}
